<template>
  <!-- «واتساب ميتا (الرسمي)» as a choice of a send-method setting (v-model = the setting).
       as="tile":   a clickable tile like the page's other method tiles (the page gives the classes);
       as="option": an <option value="meta"> inside the page's own <select v-model> (disabled while locked;
                    put <meta-method-hint> under the select: the lock line / what «meta» does). -->
  <option v-if="as == 'option'" value="meta" :disabled="locked && value != 'meta'">{{ label }}{{ locked ? ' — مقفل: يحتاج التفعيل' : '' }}</option>
  <div
    v-else
    :class="['mc-tile', value == 'meta' ? 'active' : '', locked ? 'mc-tile-locked' : '']"
    role="button"
    tabindex="0"
    :aria-pressed="value == 'meta' ? 'true' : 'false'"
    @click="pick"
    @keydown.enter.prevent="pick"
    @keydown.space.prevent="pick"
  >
    <feather-icon :icon="locked ? 'LockIcon' : 'CheckCircleIcon'" size="16" class="mc-tile-ico" />
    {{ label }}
    <small class="mc-tile-sub" v-if="locked">يحتاج تفعيل واتساب ميتا — اضغط للتفاصيل</small>
    <small class="mc-tile-sub" v-else>رسائل رسمية بقوالب معتمدة من Meta</small>
  </div>
</template>

<script>
import { META_LABEL, metaState, metaStateNow, metaPick } from '@/libs/meta-channel'

export default {
  name: 'MetaMethodOption',
  props: {
    value: { type: String, default: '' },
    as: { type: String, default: 'tile' },
    label: { type: String, default: META_LABEL },
  },
  data() {
    return { s: metaStateNow() }
  },
  computed: {
    locked() {
      return !this.s.ready
    },
  },
  created() {
    metaState()
  },
  methods: {
    pick() {
      var g = this
      metaPick(g).then(function (ok) {
        if (ok) {
          g.$emit('input', 'meta')
          g.$emit('change', 'meta')
        }
      })
    },
  },
}
</script>
